<template>
    <div id="layout_wrapper" v-if="isLoaded">
        <BuyLayout
            v-if="detailController.type == campaignType.Buy"
            :lbl="lbl"
            :locale="localeCode"
            :isLogin="isLogin"
            :userType="userType"
            :detailController="detailController"/>
        <NewsLayout
            v-else-if="detailController.type == campaignType.Event || detailController.type == campaignType.News" 
            :lbl="lbl"
            :locale="localeCode"
            :userType="userType"
            :detailController="detailController" />
        <DefaultLayout
            v-else
            :lbl="lbl"
            :locale="localeCode"
            :isLogin="isLogin"
            :userType="userType"
            :detailController="detailController" />
        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
//helper
import Vue from 'vue';
// import Account from '@/helper/AccountHelper.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import BuyLayout from '../component/layout/Buy.vue';
import DefaultLayout from '../component/layout/Default.vue';
import NewsLayout from '../component/layout/News.vue';
//core
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//controller
import { DetailController } from "../controller/DetailController.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { ConfirmRedeemModalController } from "@/components/Modal/Controller/ConfirmRedeemModalController.js";
import { ShippingModalController } from "@/components/Modal/Controller/ShippingModalController.js";
import { SerialModalController } from "@/components/Modal/Controller/SerialModalController.js";
import { VerifyCodeModalController } from "@/components/Modal/Controller/VerifyCodeModalController.js";
import { SuccessModalController } from "@/components/Modal/Controller/SuccessModalController.js";
import { AddToCartModalController } from "@/components/Modal/Controller/AddToCartModalController.js";

import Util from "../../../helper/Utility.js";
//service
import BlobService from '@/core/BlobService/service/BlobService.js';

export default {
    name: "Campaign",
    mixins: [
        AccountMixin,
        LocaleMixin,
        ErrorApiMixin
    ],
    components: {
        ModalMaster,
        BuyLayout,
        DefaultLayout,
        NewsLayout
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            //campaign
            isLoaded: false,
            campaignConfig: null,
            detailController: new DetailController(),
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            confirmModal: new ConfirmModalController(),
            loadingModal: new LoadingModalController(),
            confirmRedeemModal: new ConfirmRedeemModalController(),
            shippingModal: new ShippingModalController(),
            serialModal: new SerialModalController(),
            verifyCodeModal: new VerifyCodeModalController(),
            successModal: new SuccessModalController(),
            addToCartModal: new AddToCartModalController(),

            trackingService: new TrackingService(this),

            campaignType: Vue.CampaignType,
        };
    },
    created: function() {
        //modal4
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setConfirmModal(this.confirmModal);
        this.modalController.setLoadingModal(this.loadingModal);

        this.modalController.setConfirmRedeemModal(this.confirmRedeemModal);
        this.modalController.setShippingModal(this.shippingModal);
        this.modalController.setSerialModal(this.serialModal);
        this.modalController.setVerifyCodeModal(this.verifyCodeModal)
        this.modalController.setSuccessModal(this.successModal)
        this.modalController.setAddToCartModal(this.addToCartModal)

        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);
    },
    mounted: function () {
        this.loadingModal.show();
    },
    methods: {
        //#region mixin
        getAccountInitiated: function () {
             this.initialConfig();
        },
        //#endregion
        initialConfig: async function () {
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
            }
            // var landingCache = Account.getCacheCustom("isfromlanding")
            // if (landingCache != undefined) {
            //     if (landingCache.page == 'interface'){
            //         Account.removeCacheCustom("isfromlanding");
            //         history.go(-2);
            //     } else if (landingCache.page == 'other'){
            //         Account.removeCacheCustom("isfromlanding");
            //         history.go(-2);
            //     }
            // }

            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            var bzbsToken = this.getToken();
            this.detailController.initialCampaign(bzbsToken, this.campaignConfig, this.modalController);

            this.detailController.cbGetCampaignSuccess.onCallback(this.getCampaignSuccess);
            this.detailController.cbUpdatePoint.onCallback(this.updateUserPoint);
            this.detailController.cbApiResponseError.onCallback(this.detailApiError);

            //horoscope
            let horoscopeCatgory = await this.getHoroScopeBlobConfig();
            this.detailController.setHoroscopeCategory(horoscopeCatgory);
        },
        //#region detail controller callback
        getCampaignSuccess: function () {
            this.isLoaded = true;
            this.loadingModal.hide();
        },
        detailApiError: function (err) {
            this.errorResponse(err, this.errorHandler);
        },
        //#endregion detail controller callback
        //#region horoscope campaign
        getHoroScopeBlobConfig: function(){
            return new Promise((resolve) => {
                BlobService.getHoroscopeConfig()
                    .then(res => {
                        console.log('horo', res.data);
                        resolve(res.data.category);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        //#endregion horoscope campaign
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    #layout_wrapper {
        width: 100%;
        padding: 0 20px;
    }
</style>
<style lang="scss">
    @import "./Campaign.scss";
</style>

